// extracted by mini-css-extract-plugin
export var carrierTab = "_4i-0";
export var carrierTabActive = "_4i-1 _4i-0";
export var carrierTabInactive = "_4i-2 _4i-0";
export var carrierTabLabel = "_4i-3";
export var carrierTabLabelActive = "_4i-4 _4i-3";
export var carrierTabLabelInactive = "_4i-5 _4i-3";
export var carrierTabPercentage = "_4i-6";
export var carrierTabPercentageActive = "_4i-7 _4i-6";
export var carrierTabPercentageInactive = "_4i-8 _4i-6";
export var carrierTabWinnable = "_4i-9";
export var carrierTabWinnableActive = "_4i-a _4i-9";
export var carrierTabWinnableInactive = "_4i-b _4i-9";
export var comparisonContainer = "_4i-d";
export var missingRateButton = "_4i-n";
export var missingRateButtonActive = "_4i-o _4i-n";
export var missingRateButtonInactive = "_4i-p _4i-n";
export var missingRateButtonLabel = "_4i-q";
export var missingRateButtonLabelActive = "_4i-r _4i-q";
export var missingRateButtonLabelInactive = "_4i-s _4i-q";
export var sidebar = "_4i-c";
export var strategyButton = "_4i-e";
export var strategyButtonActive = "_4i-f _4i-e";
export var strategyButtonDescription = "_4i-k";
export var strategyButtonDescriptionActive = "_4i-l _4i-k";
export var strategyButtonDescriptionInactive = "_4i-m _4i-k";
export var strategyButtonInactive = "_4i-g _4i-e";
export var strategyButtonLabel = "_4i-h";
export var strategyButtonLabelActive = "_4i-i _4i-h";
export var strategyButtonLabelInactive = "_4i-j _4i-h";
export var unitToggleButton = "_4i-t";
export var unitToggleButtonActive = "_4i-u _4i-t";
export var unitToggleButtonInactive = "_4i-v _4i-t";
export var unitToggleButtonLabel = "_4i-w";
export var unitToggleButtonLabelActive = "_4i-x _4i-w";
export var unitToggleButtonLabelInactive = "_4i-y _4i-w";